var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprise({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00b538;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.55,18.63v-3.99c.16-.76.75-1.43,1.67-1.43h21.56c.89,0,1.64.7,1.65,1.54l.02,3.69c0,.73-.46,1.51-1.24,1.69l-8.94,2v1.77c0,.28-.18.61-.51.61h-3.42c-.32,0-.59-.19-.59-.52l-.03-1.86-8.92-1.99c-.76-.17-1.12-.85-1.25-1.5ZM21.87,20.03c.44.02.43.74.36,1l8.43-1.88c.51-.11.68-.28.68-.82l-.02-3.55c0-.22-.24-.45-.5-.45H9.18c-.31,0-.5.27-.5.53v3.75c0,.17.19.43.38.47l8.72,1.95c-.13-.41,0-1,.4-1.01,1.23-.04,2.43-.04,3.7.01ZM18.84,21.09v2.31h2.31v-2.31h-2.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.76,21.8c0-.39.2-.61.48-.66.25-.04.64.17.64.53v7.47c0,.91-.78,1.6-1.67,1.6H9.7c-.91,0-1.58-.85-1.58-1.69v-7.39c0-.3.34-.53.54-.53.34,0,.58.25.58.62v7.37c0,.23.21.5.46.5h20.59c.25,0,.46-.28.46-.5v-7.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.96,10.37h-5.87c-.93.1-.04,1.65-1.02,1.68-.48.01-.55-.29-.59-.72-.1-1,.5-2.06,1.61-2.06h5.83c1.11,0,1.72,1.06,1.61,2.07-.03.31-.09.56-.31.68-.19.1-.7,0-.74-.23-.14-.84.03-1.32-.52-1.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprise);
export default __webpack_public_path__ + "static/media/enterprise.194df91841ea525d6c52e4273417ab44.svg";
export { ForwardRef as ReactComponent };